import { __awaiter } from "tslib";
import memoizeValidator from './memoizeValidator';
const isDefined = Boolean;
const isPromise = (possiblePromise) => typeof (possiblePromise === null || possiblePromise === void 0 ? void 0 : possiblePromise['then']) === 'function';
const isNotPromise = (possiblePromise) => !isPromise(possiblePromise);
function combineAsyncResults(asyncValidations) {
    return __awaiter(this, void 0, void 0, function* () {
        // in theory this could be more efficient by waiting for
        // any async validator to resolve, and ignoring the others
        // if it resolved to an error. In practice this isn't likely
        // to be used very often, so the implementation is being kept
        // simple!
        const resolvedResults = yield Promise.all(asyncValidations);
        return resolvedResults.filter(isDefined)[0];
    });
}
export function combineValidators(...unmemoizedValidators) {
    // we have to memoize each validator, otherwise blurring a field causes validation state to reset
    const validators = unmemoizedValidators.map(memoizeValidator);
    // don't bother combining if we only have a single validator
    if (validators.length === 1)
        return validators[0];
    return (...validatorArgs) => {
        const validationResults = validators
            .filter(isDefined) //ignore empty validators
            .map((validator) => validator(...validatorArgs))
            .filter(isDefined); //ignore valid results
        if (validationResults.some(isPromise)) {
            const nonPromiseResults = validationResults.filter(isNotPromise);
            // if there are non-async validation errors, just return straightaway
            // and don't bother waiting for async ones
            if (nonPromiseResults.length > 0) {
                return nonPromiseResults[0];
            }
            // normally it's not great to return an async function from within a
            // sync one, but the framework will recognised we've returned a Promise
            // and adapt accordingly
            return combineAsyncResults(validationResults.filter(isPromise));
        }
        // just return the first validation errors - if there are none,
        // this will be undefined, meaning success
        return validationResults[0];
    };
}
// could be made more concise, but written this way to make the logic clear
export const isEmpty = (value) => {
    if (value === null || typeof value === 'undefined') {
        return true;
    }
    // boolean check;
    // only treat `false` as empty
    if (typeof value === 'boolean') {
        return value === false;
    }
    // array check;
    if (Array.isArray(value)) {
        return value.length === 0;
    }
    // string check;
    if (typeof value === 'string') {
        return value.trim() === '';
    }
    // object check;
    // using `for` loop for performance so that we can exit the loop immediately
    if (typeof value === 'object') {
        for (const key in value) {
            if (value.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }
    return false;
};
//# sourceMappingURL=validation.js.map